/**
 * @file Utility that needs description.
 * @copyright Copyright (c) 2018-present, Graham Fairweather
 * @module _replace
 */

import _methodize from './_methodize';

export default _methodize(String.prototype.replace);
